<template>
  <div class="container page">
    <van-nav-bar :title="$t('bindCard.title')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="main-box">
      <div class="label">{{ $t('bindCard.msg') }}</div>
      <van-cell-group>
<!--        <van-field v-model="financial_institution"   :label="$t('bindCard.financial_institution')"  :placeholder="$t('bindCard.truefinancial_institution')" />
        <van-field v-model="branch" :label="$t('bindCard.branch')"  :placeholder="$t('bindCard.truebranch')" />-->
        <van-field v-model="branch_number" :disabled="is_bind" :label="$t('bindCard.name')"  :placeholder="$t('bindCard.truename')" />
        <van-field v-if="$store.getters.getBaseInfo.withraw_bank_list.length == 0" v-model="bank" :label="$t('bindCard.branch')"  :placeholder="$t('bindCard.truebranch')" />
        <van-field v-else readonly clickable :label="$t('bindCard.branch')"  :placeholder="$t('bindCard.truebranch')" :value="bank" @click="showBank = true" />
        <van-field v-model="bankid" :disabled="is_bind" :label="$t('bindCard.card')" :placeholder="$t('bindCard.truecard')" />
      </van-cell-group>
      <p>{{ $t("bindCard.hint") }}</p>
    </div>
    <van-button class="bindCard" type="default" @click="bindCard()">{{ $t("msg.确认绑卡") }}</van-button>
    <van-popup v-model="showBank" round position="bottom" :style="{ height: '35%' }" >
      <van-picker
          show-toolbar
          :cancelButtonText="$t('msg.cancel')"
          :confirmButtonText="$t('msg.确定')"
          :columns="$store.getters.getBaseInfo.withraw_bank_list"
          @confirm="onConfirm"
          @cancel="onCancel"
      >

      </van-picker>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banks: [],
      showBank:false,
      userInfo:{},
      bankid:"",
      bank:"",
      financial_institution:"",
      branch:"",
      branch_number:"",
      is_bind: false,
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    bindCard(){
      /*if(this.financial_institution === "" || this.financial_institution === null || this.financial_institution === undefined){
        this.$toast(this.$t('bindCard.truefinancial_institution'));
        return true;
      }
      if(this.branch === "" || this.branch === null || this.branch === undefined){
        this.$toast(this.$t('bindCard.truebranch'));
        return true;
      }*/
      if(this.bank === "" || this.bank === null || this.bank === undefined){
        this.$toast.fail(this.$t('bindCard.truename'));
        return false;
      }
      if(this.branch_number === "" || this.branch_number === null || this.branch_number === undefined){
        this.$toast(this.$t('bindCard.truebranch_number'));
        return true;
      }
      if(this.bankid === "" || this.bankid === null || this.bankid === undefined){
        this.$toast(this.$t('bindCard.truecard'));
        return true;
      }
      this.$http({
        method: 'get',
        data:{bankid:this.bankid,bank:this.bank,financial_institution:this.financial_institution,branch:this.branch,branch_number:this.branch_number},
        url: 'user_set_bank'
      }).then(res=>{
        if(res.code === 200){
          this.$router.push({path:'/Mine'})
        }
        this.$toast(this.$t("msg."+res.msg));
      })
    },
    showSelectBanks(){
      this.showBank = true;
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getBankList(){
      this.$http({
        method: 'get',
        url: 'sys_get_banks'
      }).then(res=>{
        if(res.code === 200){
          this.banks = res.data;
        }else if(res.code ===401){
          this.$toast(this.$t("msg."+res.msg));
        }
      })
    },
    onConfirm(value) {
      this.bank = value.text
      this.showBank = false;
    },
    onCancel() {
      this.showBank = false;
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.is_bind = true;
            this.financial_institution = res.data.info.financial_institution;
            this.branch = res.data.info.branch;
            this.bankid = res.data.info.bankid;
            this.bank = res.data.info.bankinfo;
            this.branch_number = res.data.info.branch_number;

          }else {
            this.is_bind = false;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      //this.getBankList();
      //this.getBankList();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 16PX;
  line-height: 40PX;
}
.van-hairline--bottom::after {
  border-bottom-width: 3PX;
}
.bankbox{
  padding: 15PX;
  color: #000;
  background-color: #fff;
}
.bankbox .title{
  padding: 8PX 10PX 20PX;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 28PX;
}
.main-box{
  background: #fff;

}
.main-box .label{
  padding: 20PX;
  font-size: 18PX;
  color: #797878;
}
::v-deep .van-picker__toolbar {
  height: 80px;
}
::v-deep .van-picker__cancel, .van-picker__confirm {
  padding: 0 30px;
  font-size: 40px;
}
::v-deep .van-picker-column {
  font-size: 40px;
}
::v-deep .van-picker__confirm {
  padding: 0 30px;
  font-size: 40px;
}
.main-box p{
  padding: 0 20PX;
  font-size: 14PX;
  color: #ee0a24;
}
.bindCard {
  display: inline-block;
  width: 90%;
  background: linear-gradient(180deg, #fc78af, #f22678);
  color: #fff;
  padding: 30PX 0;
  border-radius: 10PX;
  font-size: 16PX;
  cursor: pointer;
  margin: 1.66667rem auto 3.33333rem;
}
</style>
